import { _ as __assign, a as __awaiter, b as __generator } from '../../chunks/bundle-C7jYHvwG.js';
import React__default from 'react';
import { F as FileViewerView } from '../../chunks/bundle-LWpHaUiZ.js';
import { useGroupChannelContext } from '../context.js';
import { useSendbirdStateContext } from '../../useSendbirdStateContext.js';
import 'react-dom';
import '../../chunks/bundle-CbEyAimK.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-DUTyBaXr.js';
import '../../chunks/bundle-BR3O1lZq.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-DImSV9VW.js';
import '../../chunks/bundle-pOZPN8hk.js';
import '../../chunks/bundle-DYeeW5nS.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-CDjVXDOc.js';
import '../../chunks/bundle-Dl9NVsui.js';
import '../../chunks/bundle-DkviGBGz.js';
import '../../chunks/bundle-MyLy9AIu.js';
import '../../chunks/bundle-CIN9yQRB.js';
import '../../chunks/bundle-DfDrbjM5.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '@sendbird/uikit-tools';
import '../../withSendbird.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-4W3uBGU3.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-CLonR-iH.js';
import '../../chunks/bundle-C6-Ix-Lk.js';
import '../../ui/SortByRow.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-gQ2a8Eki.js';
import '../../chunks/bundle-MrMJJXf2.js';
import '../../chunks/bundle-ryUmMhVP.js';
import '../../chunks/bundle-C1U8wE49.js';
import '../../chunks/bundle-Dpdq7qeD.js';
import '../../chunks/bundle-90vsNbxW.js';
import '../../chunks/bundle-MkyS3j4-.js';
import '../../chunks/bundle-LPNnEgGp.js';

var FileViewer = function (props) {
    var _a = useGroupChannelContext(), deleteMessage = _a.deleteMessage, onBeforeDownloadFileMessage = _a.onBeforeDownloadFileMessage;
    var config = useSendbirdStateContext().config;
    var logger = config.logger;
    return (React__default.createElement(FileViewerView, __assign({}, props, { deleteMessage: deleteMessage, onDownloadClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var allowDownload, err_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!onBeforeDownloadFileMessage)
                            return [2 /*return*/];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, onBeforeDownloadFileMessage({ message: props.message })];
                    case 2:
                        allowDownload = _c.sent();
                        if (!allowDownload) {
                            e.preventDefault();
                            (_a = logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'FileViewer: Not allowed to download.');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _c.sent();
                        (_b = logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'FileViewer: Error occurred while determining download continuation:', err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); } })));
};

export { FileViewer, FileViewer as default };
//# sourceMappingURL=FileViewer.js.map
